module.exports = __webpack_public_path__ + "9971912b056f281ff89f8f09dc5bb6d1.pdf";